<div class="usuario-avatar-upload" *ngIf="entity">
    <div class="usuario-avatar" #usuarioAvatarContainer>
        <sgt-avatar
            [settings]="avatarSettings"
            (onClick)="onClickAvatar()">
        </sgt-avatar>
    </div>
    <div class="dropdown usuario-avatar-dropdown" #dropdown>
        <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" tabindex="-1">
            <i class="fas fa-ellipsis-h" aria-hidden="true"></i>
        </button>
        <div class="dropdown-menu">
            <a class="dropdown-item btn-file" [class.disabled]="uploader.isUploading">
                <i class="fas fa-pencil-alt"></i> Alterar
                <input type="file" name="inputFileUsuarioAvatar" #inputFile accept="image/*" ng2FileSelect [uploader]="uploader" [disabled]="uploader.isUploading"/>
            </a>
            <a class="dropdown-item dropdown-item-delete" (click)="delete()" *ngIf="entity.avatarUrl">
                <i class="far fa-trash-alt"></i> Remover
            </a>
        </div>
    </div>
</div>
